export default __webpack_public_path__ + "static/media/interviewplan.06f8f87b.png";